import { ADMIN_API } from "./adminApi";
import { ApiOk, ChartPoint } from "./adminCommon.types";

async function getChart(path: string, params?: Record<string, any>) {
  const { data } = await ADMIN_API.get<ApiOk<ChartPoint[]>>(path, { params });
  return data.data;
}

export const getEnviosPorCliente = () => getChart("/api/admin/relatorios/envios-por-cliente");
export const getEnviosPorPeriodo = (params?: Record<string, any>) =>
  getChart("/api/admin/relatorios/envios-por-periodo", params);
export const getShopifyXNuvemshopReport = () => getChart("/api/admin/relatorios/shopify-x-nuvemshop");
export const getUpsXFedexReport = () => getChart("/api/admin/relatorios/ups-x-fedex");
export const getCrescimentoMensalReport = () => getChart("/api/admin/relatorios/crescimento-mensal");
export const getPaisesDestino = () => getChart("/api/admin/relatorios/paises-destino");
